// Register optional theme components only when their markup is present.
const config = document.getElementById('TglFeatureModules');
if (config) {
  const features = new Map(Object.entries(JSON.parse(config.textContent)));
  const selector = [...features.keys()].join(',');
  const loading = new Set();
  const loadPresent = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const components = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) components.unshift(root);
    for (const component of components) {
      const tag = component.localName;
      if (loading.has(tag) || customElements.get(tag)) continue;
      loading.add(tag);
      import(features.get(tag)).catch(() => loading.delete(tag));
    }
  };
  loadPresent(document);
  // Quick-add and section rendering can introduce a component after initial load.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) loadPresent(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
